var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 14","width":"14","height":"14"}},[_c('path',{attrs:{"stroke":"#9AAE2D","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M12.5 4l-6.667 7L2.5 8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }